import Loading from './Loading.class.js'

export default class LoginLoading extends Loading {
  showLoading() {
    super.showLoading({
      title: this.$t('LOADING_SIGNIN_TITLE'),
      description: this.$t('LOADING_SIGNIN_DESC'),
    })
  }
}
